export function getStringOrFirstElement(param: string | string[]) {
  return param instanceof Array ? param[0] : param
}

export function reverse(array: any[]) {
  return [...array].reverse()
}
